// @flow
import React, {type Node} from 'react';
import ProtocolWarningIcon from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/cryptocurrency-form/protocol-warning/protocol-warning-icon';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';

function ProtocolWarning(): Node {
  const { t } = useTranslation('payment-methods/cryptocurrency');

  return (
    <Wrapper>
      <ProtocolWarningIcon />
      <p>
        <Trans
          t={t}
          i18nKey="protocolWarning"
          components={{ b: <b /> }}
        />
      </p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  background-color: ${props => props.theme.colors.feedback.warning[100]};

  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export default ProtocolWarning;
